import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appOnlyNumeric]',
})
export class OnlyNumericDirective {
  @Input() length!: number; // Accepts the max length from the template
  constructor(
    public element: ElementRef,
    private control: NgControl
  ) {}

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
    const input = this.element.nativeElement as HTMLInputElement;
    const regex = /^[1-9][0-9]*$/;

    const value = input.value.trimStart();
    if (!regex.test(value) || (this.length && value?.length > this.length)) {
      let newValue = value.replace(/[^0-9]/g, '');
      newValue = this.length ? newValue.substring(0, this.length) : newValue;
      this.control.control?.setValue(
        input.type == 'number' ? Number(newValue) : newValue
      ); //
    }
  }
}
